import '../index.less';

import { Divider } from 'antd';

import InfoGrid from '../../../components/InfoGrid';
import { numberWithCommas } from '../../../helpers/number';
import { displayDate } from '../../../utils/datetime.util';
import { trimPhoneNo } from '../../../utils/number.util';
import { AccountEnquiryResponse } from '../../../features/collection/collectionSlice';

type EmploymentInformationProps = {
  accountEnquiry: AccountEnquiryResponse;
};

const EmploymentInformation: React.FC<EmploymentInformationProps> = (props) => {
  const { accountEnquiry } = props;

  const application = accountEnquiry?.agreementDetails?.application;

  const employmentInformation = [
    {
      title: 'Employment Type',
      value: accountEnquiry?.accountDetails?.employmentType ?? application?.applicantEmploymentType,
    },
    {
      title: 'Monthly Salary',
      value:
        application?.actualMonthlySalary != null ||
        accountEnquiry?.accountDetails?.actualMonthlySalary
          ? `RM ${numberWithCommas(
              accountEnquiry?.accountDetails?.actualMonthlySalary ??
                application?.actualMonthlySalary
            )}`
          : '-',
    },
    {
      title: 'Job Start Date',
      value: displayDate(
        accountEnquiry?.accountDetails?.employmentStartingFrom ??
          application?.employmentStartingFrom
      ),
    },
    {
      title: 'Bank Name',
      value: accountEnquiry?.accountDetails?.applicantBankName ?? application?.applicantBankName,
    },
    {
      title: 'Bank Account No.',
      value:
        accountEnquiry?.accountDetails?.applicantPersonalBankNo ??
        application?.applicantPersonalBankNo,
    },
    {
      title: 'Employer’s Name',
      value: accountEnquiry?.accountDetails?.employerName ?? application?.employerName,
    },
    {
      title: 'Employer’s Contact No.',
      value: accountEnquiry?.accountDetails?.employerContactNo
        ? trimPhoneNo(accountEnquiry?.accountDetails?.employerContactNo)
        : application?.employerContactNo
        ? trimPhoneNo(application?.employerContactNo)
        : '-',
    },
    {
      title: 'Job Title',
      value: accountEnquiry?.accountDetails?.jobTitle ?? application?.jobTitle,
    },
  ];

  return (
    <div className="account-enquiry-container">
      <div className="account-enquiry-section-container">
        <h3 className="account-enquiry-section-subtitle">Employment Information</h3>
        <Divider style={{ margin: 0 }} />
        <div className="info-container">
          <InfoGrid data={employmentInformation} />
        </div>
      </div>
    </div>
  );
};

export default EmploymentInformation;
